import { CdkColumnDef, CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { PopoverModule } from 'ngx-smart-popover';
import { AppCommonModule } from '../app-common.module';
import { ReportsModule } from '../reports/reports.module';
import { CustomerCreditLimitColumnComponent } from './credit-limit-column/credit-limit-column.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { CustomerDetailService } from './customer-detail/customer-detail.service';
import { OverviewByCustomerComponent } from './customer-detail/overview/overview-by-customer.component';
import { AgingByCustomerReportComponent } from './customer-detail/reports/aging/aging-by-customer.report.component';
import { CollectionsByCustomerReportComponent } from './customer-detail/reports/collections/collections-by-customer.report.component';
import { IneligiblesByCustomerReportComponent } from './customer-detail/reports/ineligibles/ineligibles-by-customer.component';
import { PurchasesByCustomerReportComponent } from './customer-detail/reports/purchases/purchases-by-customer.component';
import { PurchasesByCustomerExpandableRowComponent } from './customer-detail/reports/purchases/purchases-by-customer.expandable-row.component';
import { PurchasesByCustomerGroupedTableComponent } from './customer-detail/reports/purchases/purchases-by-customer.grouped-table.component';
import { PurchasesByCustomerGroupedTableHeaderComponent } from './customer-detail/reports/purchases/templates/purchases-by-customer.grouped-table-header.component';
import { PurchasesByCustomerMobileGroupedTableComponent } from './customer-detail/reports/purchases/templates/purchases-by-customer.mobile-grouped-table.component';
import { CustomerInfoColumnComponent } from './customer-info-column/customer-info-column.component';
import { CustomersRoutingModule } from './customers-routing.module';
import { CustomersComponent } from './customers.component';
import { CreditStatusCardComponent } from './new-customer-credit/credit-status-card/credit-status-card.component';
import { NewCustomerCreditComponent } from './new-customer-credit/new-customer-credit.component';
import { SearchCustomerCardComponent } from './new-customer-credit/search-customer-card/search-customer-card.component';
import { InvoicePreviewButtonColumnComponent } from './table-columns/invoice-preview-button-column.component';

@NgModule({
    imports: [
        AppCommonModule,
        LsqCommonModule.forChild(),
        CustomersRoutingModule,
        PopoverModule,
        CdkTableModule,
        LsqTablesModule.forChild(),
        ReportsModule
    ],
    declarations: [
        CustomersComponent,
        CustomerDetailComponent,
        AgingByCustomerReportComponent,
        CollectionsByCustomerReportComponent,
        CreditStatusCardComponent,
        IneligiblesByCustomerReportComponent,
        PurchasesByCustomerReportComponent,
        NewCustomerCreditComponent,
        SearchCustomerCardComponent,
        OverviewByCustomerComponent,
        CustomerCreditLimitColumnComponent,
        CustomerInfoColumnComponent,
        InvoicePreviewButtonColumnComponent,

        // Purchases:
        PurchasesByCustomerExpandableRowComponent,
        PurchasesByCustomerGroupedTableComponent,
        PurchasesByCustomerMobileGroupedTableComponent,
        PurchasesByCustomerGroupedTableHeaderComponent
    ],
    providers: [CustomerDetailService, CdkColumnDef]
})
export class CustomersModule {}
